import { render, staticRenderFns } from "./BaseMultiselect.vue?vue&type=template&id=3e1b1496&"
import script from "./BaseMultiselect.vue?vue&type=script&lang=ts&"
export * from "./BaseMultiselect.vue?vue&type=script&lang=ts&"
import style0 from "./BaseMultiselect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports